
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { AdvisorFinder } from "@components/contact/advisor-finder";
import { ContactHero } from "@components/contact/contact-hero";
import { Departments } from "@components/contact/departments";
import { Headquarters } from "@components/contact/headquarters";
import { HelpTopics } from "@components/contact/help-topics";
import { PartnerCta } from "@components/contact/partner-cta";
import { NextSeo } from "@components/seo";
import type { ContactPageData } from "@type/contact";
import { getContactPageData } from "@utils/get-contact-page";
import type { GetStaticProps, NextPage } from "next/types";
import useTranslation from "next-translate/useTranslation";
interface ContactProps {
    data: ContactPageData;
}
const Contact: NextPage<ContactProps> = ({ data }) => {
    const { t } = useTranslation("contact");
    return (<>
      <NextSeo description={t("seo.description")} languageAlternates={[
            { href: "https://knsokna.pl/contact", hrefLang: "x-default" },
            { href: "https://knswindows.com/contact", hrefLang: "en" },
            { href: "https://knsokna.pl/contact", hrefLang: "pl" },
            { href: "https://knsfenster.de/contact", hrefLang: "de" },
            { href: "https://kns-okna.eu/contact", hrefLang: "cs" },
            { href: "https://knsfinestre.it/contact", hrefLang: "it" },
            { href: "https://knsfenetres.fr/contact", hrefLang: "fr" },
            { href: "https://knsokna.eu/contact", hrefLang: "hu" },
        ]} title={t("seo.title")}/>
      <div className="bg-white">
        <ContactHero company={data.company} primaryContact={data.primaryContact}/>
        <HelpTopics topics={data.helpTopics}/>
        <Departments departments={data.departments} salesDesk={data.salesDesk}/>
        {data.advisorNetwork && <AdvisorFinder network={data.advisorNetwork}/>}
        <Headquarters company={data.company}/>
        <PartnerCta />
      </div>
    </>);
};
const getStaticProps: GetStaticProps<ContactProps> = async ({ locale = "pl", }) => ({
    props: {
        data: await getContactPageData(locale),
    },
});
export default Contact;

    async function __Next_Translate__getStaticProps__1a19cd2bed4__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/contact',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bed4__ as getStaticProps }
  